import { Box } from 'components/index';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import get from 'lodash/get';
import { Controller } from 'react-hook-form';
import React from 'react';
import FlexRow from '../../../shared/FlexRow';
import { Button, CheckBox, DatePicker } from '../../../shared';
import { IWTFieldArrayHelper } from '../types';
import { IExperience } from '../../../../api/types/queries/employeeProfile';

const RenderExperience = ({
  experience,
  errors,
  control,
  validate,
  RenderFormInput,
}) => {
  const baseExperience = {
    name: '',
    pos: '',
    startDate: new Date(),
    endDate: new Date(),
    currentJob: false,
  } as IWTFieldArrayHelper<IExperience>;

  return (
    <Box className={'sectionContainer'}>
      <Typography variant={'h2'}>Work History</Typography>
      <Typography
        variant={'h5'}
        className={'sectionDescription'}
      >
        Connect your work history to your employer to rate them
        and get insights to other similar employers. Ask your
        employer for their code to connect your account.
      </Typography>
      <FlexRow className={'history-container'}>
        {experience.fields.length === 0 && (
          <Typography variant={'body1'}>
            No Experience
          </Typography>
        )}
        {experience.fields.map((field, index) => (
          <Paper
            elevation={3}
            key={field.id}
            className={[
              'history-item',
              get(
                errors,
                `experience.${index}.currentJob.message`,
                null,
              )
                ? 'error'
                : '',
            ].join(' ')}
          >
            <Button
              onClick={() => experience.remove(index)}
              size={'small'}
              variant={'outlined'}
              color={'primary'}
            >
              Delete
            </Button>
            <Controller
              name={`experience.${index}.currentJob`}
              control={control}
              rules={{
                validate: validate.current('experience', index),
              }}
              render={({ field: controllerField }) => (
                <CheckBox
                  {...controllerField}
                  label={'Current Job'}
                  labelPlacement={'start'}
                  checked={controllerField.value}
                  type={'checkbox'}
                />
              )}
            />
            <RenderFormInput
              label={'Name'}
              name={`experience.${index}.name`}
              registerOptions={{
                required: 'Experience Name is required',
              }}
              error={get(
                errors,
                `experience.${index}.name.message`,
                null,
              )}
            />
            <RenderFormInput
              label={'Job Title'}
              name={`experience.${index}.pos`}
              registerOptions={{
                required: 'Job Title is required',
              }}
              error={get(
                errors,
                `experience.${index}.pos.message`,
                null,
              )}
            />
            <Controller
              name={`experience.${index}.startDate`}
              control={control}
              rules={{
                validate: validate.dateBefore(
                  'experience',
                  index,
                ),
              }}
              render={({ field: controllerField }) => (
                  <DatePicker
                    {...controllerField}
                    error={get(
                      errors,
                      `experience.${index}.startDate.message`,
                      null,
                    )}
                    label={'Start Date'}
                    inputFormat="MM/YYYY"
                    views={['month', 'year']}
                  />
                )
              }
            />
            <Controller
              name={`experience.${index}.endDate`}
              control={control}
              rules={{
                validate: validate.dateAfter(
                  'experience',
                  index,
                ),
              }}
              render={({ field: controllerField }) => (
                <DatePicker
                  {...controllerField}
                  error={get(
                    errors,
                    `experience.${index}.endDate.message`,
                    null,
                  )}
                  label={'Finish Date'}
                  inputFormat="MM/YYYY"
                  views={['month', 'year']}
                />
              )}
            />
            {/*show error for current job if exists*/}
            {get(
              errors,
              `experience.${index}.currentJob.message`,
              null,
            ) && (
              <Typography
                paragraph
                variant={'body2'}
                color={'error'}
              >
                {get(
                  errors,
                  `experience.${index}.currentJob.message`,
                  null,
                )}
              </Typography>
            )}
          </Paper>
        ))}
      </FlexRow>
      <Button
        onClick={() => experience.append(baseExperience)}
        variant={'outlined'}
        color={'secondary'}
        size={'small'}
      >
        Add Work History
      </Button>
    </Box>
  );
};

export default RenderExperience;
